import { useNavigate } from 'react-router-dom';
import { useProdStat } from '@hooks/graphql/useProdStatData';
import { useDateNavigation } from '@hooks/graphql/useDateNavigation';

const useProdStatValidateList = () => {
  const navigate = useNavigate();

  const { selectedPeriod, pickerValue, handleDateChange } = useDateNavigation();

  const {
    data,
    loading,
    saving,
    handleEdit,
    handleSaveRow: originalHandleSaveRow,
    handleUndoRow,
    isUndoDisabled,
    isRowOriginallyApproved,
    handleMoveMeters,
    handleDecommission,
    saveFeedback,
    moveFeedback,
    savedRowIds,
    availableLocations,
    refetch,
  } = useProdStat({
    type: 'corrupted',
    monthYear: selectedPeriod,
  });

  const handleSaveRow = (id: number, options?: { ignored?: boolean; markInactive?: boolean }) => {
    return originalHandleSaveRow(id, options);
  };

  return {
    navigate,
    selectedPeriod,
    pickerValue,
    handleDateChange,
    data,
    loading,
    saving,
    handleEdit,
    handleSaveRow,
    handleUndoRow,
    isUndoDisabled,
    isRowOriginallyApproved,
    handleMoveMeters,
    handleDecommission,
    saveFeedback,
    moveFeedback,
    savedRowIds,
    availableLocations,
    refetch,
  };
};

export default useProdStatValidateList;